import { useApiModel } from '@hooks/use-api-model';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type { IScreeningCompleteModel, IScreeningCompleteResponse } from '@/types/screening/screening-complete';
import { defaultScreeningResultsModel, type IScreeningResultsModel } from '@/types/screening/screening-results';

const SCREENING_COMPLETE_ENDPOINT = '/api/register/screening-complete';

const defaultScreeningCompleteModel: IScreeningCompleteModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.ScreeningComplete,
};

interface IScreeningCompletePageModel {
    completeModel: IScreeningCompleteModel;
    resultsModel: IScreeningResultsModel;
}

const defaultScreeningCompletePageModel: IScreeningCompletePageModel = {
    completeModel: defaultScreeningCompleteModel,
    resultsModel: defaultScreeningResultsModel,
};

export const useScreeningComplete = (registrationId: number, editKey: string) => {
    const url = `${SCREENING_COMPLETE_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel<IScreeningCompletePageModel, IScreeningCompleteResponse['results']>(
        url,
        defaultScreeningCompletePageModel,
        (r) => ({
            completeModel: { ...defaultScreeningCompleteModel, ...r.completeResults },
            resultsModel: { ...defaultScreeningResultsModel, ...r.screeningResults },
        }),
    );

    return { completeModel: model.completeModel, resultsModel: model.resultsModel, isLoading, error };
};
